module.exports = __webpack_public_path__ + "img/line-bg.857bb299.png";